import request from "./../utils/request";

export function getFilters(key) {
    return request.get(`/fav-filters/${key}`);
}

export function createFilter(key, name, filters) {
    return request.post(`/fav-filters`, {
        name,
        key,
        filters,
    });
}

export function updateFilter(id, name, filters) {
    return request.patch(`/fav-filters/${id}`, {
        name,
        filters,
    });
}

export function deleteFilter(id) {
    return request.delete(`/fav-filters/${id}`);
}
